"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = void 0;
var _fetching = require("@ori/fetching");
/**
 * Utility function for generating core, user segmentation and products headers for HTTP requests. Returns object with headers.
 * @example
 *
 * const headers = getHeaders({
 *       sourceAppName: 'app',
 *       language: 'cs',
 *       customerId: 1,
 *       tenant: 'cz',
 *       token: 'some-token',
 *     }),
 *
 * useGraphqlQuery({query, url, headers: headers})
 */
const getHeaders = ({
  atpClusterId,
  customerId,
  customerTypeId,
  language,
  sourceAppName,
  tenant,
  token,
  useProductDataCaching = true,
  useProductsService = true,
  visitorSegment
}) => {
  const headers = (0, _fetching.getHeaders)({
    customerId,
    language,
    sourceAppName,
    tenant,
    token
  });
  if (atpClusterId != null) {
    headers[_fetching.ATP_CLUSTER_ID] = atpClusterId;
  }
  if (visitorSegment != null) {
    headers[_fetching.VISITOR_SEGMENT] = visitorSegment;
  }
  headers[_fetching.CUSTOMER_TYPE_ID] = customerTypeId ?? 0;
  headers[_fetching.USE_PRODUCTS_SERVICE] = useProductsService;
  headers[_fetching.USE_PRODUCT_DATA_CACHING] = useProductDataCaching;
  return headers;
};
exports.getHeaders = getHeaders;
